export default __webpack_public_path__ + "static/media/medication-tracker.00ccb930.png";